import React, {useEffect, useRef,useState } from "react"; 
import {  Modal } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
 
import {gameCreate,updateGame} from "../../../Services/Games/gamesService"
import {getGrades,getCategories} from "../../../Services/gameServices"
import {getSubjects} from "../../../Services/Subjects/SubjectServices"

import Form from 'react-bootstrap/Form';
import {toast } from 'react-toastify';
import{handleFileValidation}from"../../../utils/Api" 
const CreateGame = ({popupType,editdata, isShow,close,tablererender }) => {   
  var error=false;
  let[title,setTitle]             = useState('')
  let[description,setDescription] = useState('')  
  let[asset,setAsset]             = useState(null)
  let[banner,setBanner]           = useState(null)
  let[grade_id,setGradeid]        = useState('')   

  const titleRef        = useRef(null); 
  const descriptionRef  = useRef(null);  
  const handleClose     = () => {setShow(false);close()};
  const [show, setShow] = useState(false); 
  const [grades,setGrades]          = useState([])  
  const [isLoading, setIsloading]   = useState(false);
  const [concepts,setConcepts]      = useState([]) 
  const [category,setCategory]      = useState([]) 
  const [subjectId,setSubjectId]    = useState('') 
  const [categoryId,setCategoryId]  = useState('')  
  
  const [subjectIdError,setSubjectIdError]  = useState(false);
  const [titleError, setTitleError]         = useState(false);
  const [descriptionError, setDescriptionError] = useState(false); 
  const [gradeIdError, setGradeIdError]     = useState(false);
  const [assetError, setAssetError]         = useState(false);
  const [bannerError, setBannerError]       = useState(false); 
  const [categoryError, setCategoryError]       = useState(false); 
  
 
  const handleSubmit = async (e) => {
  if (!title.trim() || !description.trim()|| !grade_id ||!categoryId  ) {
    setTitleError(!title.trim());
    setDescriptionError(!description.trim())
    if (title.trim().length<=3) {
      setTitleError(true);   
    } 
    setGradeIdError(!grade_id)
    setCategoryError(!categoryId) 
    let object = [
        {
            key: title.trim(),
            ref: titleRef.current,
        },
        {
            key: description.trim(),
            ref: descriptionRef.current,
        },
    ];

    for (let i = 0; i < object.length; i++) {
        if (!object[i].key) {
            object[i].ref.focus();
            break;
        }
    }
    error=true;
    }
    if(popupType=='CREATE'){
      if(!asset || !banner){
        setAssetError(!asset)
        setBannerError(!banner)
        error=true;
      }
    }
    if(error){
      return true
    } 

    if (title.trim().length<=3) {
      setTitleError(true);  
      return;
    }
     
    // e.preventDefault();
    const formData = new FormData();
    formData.append('game_id', editdata?.id);
    formData.append('title', title.trim());
    formData.append('description', description.trim());  
    formData.append('asset', asset);
    formData.append('banner', banner);
    formData.append('grade_id', grade_id); 
    formData.append('categoryId', categoryId); 
    formData.append('subjectId', subjectId); 
    setIsloading(true)
    if(popupType=='CREATE'){
      gameCreate(formData).then((Response)=>{
        setIsloading(false)
        if(Response.status){ 
          close()
          tablererender()
          toast.success(Response.message) 
        }else{
          toast.error(Response.errorMessage)
        } 
      }) 
    }else{
      updateGame(formData).then((Response)=>{
        setIsloading(false)
        if(Response.status){ 
          close()
          tablererender()
          toast.success(Response.message) 
        }else{
          toast.error(Response.errorMessage)
        } 
      }) 
    }
   
 
  }; 

  const handleThumbnailChange = (e) => handleFileValidation(e, setAsset,setAssetError);
  const handleBannerChange = (e) => handleFileValidation(e, setBanner,setBannerError);
  
  useEffect(() => { 
    if(popupType=='EDIT'){
      console.log(editdata?.game_name)
      setTitle(editdata?.game_name)
      setDescription(editdata?.description)
      setGradeid(editdata?.grade_id)
      setSubjectId(editdata?.subject_id)
      setCategoryId(editdata?.category_id) 
      console.log('editdata',editdata)
    }

    getGrades().then(data=>{
      if(data.status){
        setGrades(data.data) 
      } 
    }) 
    getSubjects().then(data=>{
      if(data.status){
        setConcepts(data.data) 
      } 
    }) 
    setShow(isShow)
  }, [isShow]); 

  useEffect(() => {
    const fetchCategories = async () => {
      if (!subjectId) {
        setCategory([]);
        return;
      }
  
      try {
        const data = await getCategories(subjectId);
        setCategory(data.status ? data.data : []);
      } catch (error) {
        console.error("Failed to fetch categories:", error);
        setCategory([]);
      }
    };
  
    fetchCategories();
  }, [subjectId]);
  

 
  return ( 
    <Modal show={show} onHide={handleClose} backdrop="static" className="modal-xl">
        <Modal.Header closeButton>
          <h5 className="modal-title">{popupType=='CREATE'?'Add':'Update'} Game</h5>
        </Modal.Header>
        <Modal.Body>
            <form className="row g-3" >
           
                <div className="col-6 px-3">
                    <label htmlFor="gamename" className="form-label required">Game Name {title}</label>
                    <input 
                    onChange={(e) => {setTitle(e.target.value)
                    if (titleError && e.target.value.trim() !== '') {
                          setTitleError(false);
                    }}} 
                    id='gamename' 
                    ref={titleRef}
                    type="text" 
                    name="name" 
                    value={title}
                    className="form-control"  
                    placeholder="Enter Game Name" 
                    maxLength={50}
                    />
                    <Form.Control.Feedback type="invalid" style={{ display: titleError ? 'block' : 'none' }}>
                    Game Name is required and must be more than 3 characters
                </Form.Control.Feedback>
                </div> 
                <div className="col-6 px-3">
                    <label htmlFor="gamedescription" className="form-label required">Game Description {description}</label>
                    <input 
                    onChange={(e) => {setDescription(e.target.value)
                    if (descriptionError && e.target.value.trim() !== '') {
                          setDescriptionError(false);
                    }}} 
                    id='gamedescription' 
                    ref={descriptionRef}
                    type="text" 
                    name="description" 
                    className="form-control"  
                    placeholder="Enter Game Description" 
                    value={description}
                    maxLength={250}
                    />
                    <Form.Control.Feedback type="invalid" style={{ display: descriptionError ? 'block' : 'none' }}>
                    Game Description is required
                </Form.Control.Feedback>
                </div> 
             
                <div className="col-6 px-3">
                    <label htmlFor='Newsubject' className="col-sm-2 col-form-label form-label required">Subject</label>
                    <div className="col-sm-10">
                        <select  
                            className="form-control" 
                            value={subjectId}
                            onChange={(e)=>{setSubjectId(e.target.value);setSubjectIdError(false);}}
                        >
                            <option disabled value="">Please Select Subject</option>
                            {concepts.map((obj) => (
                            <option key={obj.id} value={obj.id}>
                                {obj.name}
                            </option>
                        ))}
                        </select>
                        <Form.Control.Feedback type="invalid" style={{ display: subjectIdError ? 'block' : 'none' }}>
                    Please select Subject
                    </Form.Control.Feedback>  
                    </div>
                </div>
                <div className="col-6 px-3">
                    <label htmlFor='Newsubject' className="col-sm-2 col-form-label form-label required">Category</label>
                    <div className="col-sm-10">
                        <select  
                            className="form-control" 
                            value={categoryId}
                            onChange={(e)=>{setCategoryId(e.target.value);setCategoryError(false);}}
                        >
                            <option disabled value="">Please Select Category</option>
                            {category.map((obj) => (
                            <option key={obj.id} value={obj.id}>
                                {obj.name}
                            </option>
                        ))}
                        </select>
                        <Form.Control.Feedback type="invalid" style={{ display: categoryError ? 'block' : 'none' }}>
                    Please select category
                    </Form.Control.Feedback>  
                    </div>
                </div>

                <div className="col-6 px-3">
                    <label htmlFor='newGrade' className="col-sm-2 col-form-label form-label required">Grade</label>
                    <div className="col-sm-10">
                        <select 
                            value={grade_id} 
                            className="form-control"
                           onChange={(e)=>{setGradeid(e.target.value);setGradeIdError(false)}}
                        >
                            <option disabled value="">Please Select Grade</option>
                            {grades.map((obj) => (
                                <option key={obj.grade_id} value={obj.grade_id}>
                                    {obj.grade_name}
                                </option>
                            ))}
                        </select>
                        <Form.Control.Feedback type="invalid" style={{ display: gradeIdError ? 'block' : 'none' }}>
                    Please select grade
                    </Form.Control.Feedback>  
                    </div>
                </div>
                
                <div className="col-6 px-3">
                  <label htmlFor="gameThumnail" className={`form-label ${popupType=='CREATE'?'required':''} `}>Game Thumbnail</label>
                  <input id="gameThumnail" onChange={handleThumbnailChange}
                   name="asset" type="file" className="form-control" accept=".png, .jpg, .jpeg" />
                  <Form.Control.Feedback type="invalid" style={{ display: assetError ? 'block' : 'none' }}>
                      Game Thumbnail is required
                  </Form.Control.Feedback>
                </div>
                <div className="col-6 px-3">
                  <label htmlFor="gameBanner" className={`form-label ${popupType=='CREATE'?'required':''} `}>Game Banner</label>
                  <input id="gameBanner"  
                  onChange={handleBannerChange}
                name="asset" type="file" className="form-control" accept=".png, .jpg, .jpeg" />
                  <Form.Control.Feedback type="invalid" style={{ display: bannerError ? 'block' : 'none' }}>
                      Game Banner is required
                  </Form.Control.Feedback>
                </div>
            </form> 
        </Modal.Body>
        <Modal.Footer>
            <button
             disabled={isLoading?true:false}
            type="button"
            id="closesubject"
            className="btn btn-secondary" 
            onClick={()=>handleClose()}
          >
            Close
          </button>
          <button
           disabled={isLoading?true:false}
           onClick={handleSubmit}
            type="button"
            className="btn btn-primary"
          >
            Save
          </button>
        </Modal.Footer>
      </Modal>
       
  );
};

export default CreateGame;